class TwoZeroScroll extends HTMLElement {
    connectedCallback() {
        const letters = this.querySelectorAll('path[data-letter]')
        const sections = [
            { key: 'two', el: this.querySelector('[data-items="two"]') },
            { key: 'zero', el: this.querySelector('[data-items="zero"]') },
            { key: 'twozero', el: this.querySelector('[data-items="twozero"]') }
        ]

        const lightGray = "#B6B6B6"
        const darkGray = "#292929"

        const setState = (state) => {
            gsap.to(letters, {
                color: (i, el) => {
                    if (state === 'twozero') return darkGray
                    return el.dataset.letter === state ? darkGray : lightGray
                },
                duration: 0.75,
                ease: 'expo.out'
            })
        }

        const resetState = () => {
            gsap.to(letters, {
                color: lightGray,
                duration: 0.75,
                ease: 'expo.out'
            })
        }

        sections.forEach(({ key, el }) => {
            const items = el.children

            const resetItems = () => {
                gsap.set(items, { y: 80, opacity: 0 })
            }

            const animateItems = () => {
                gsap.to(items, {
                    y: 0,
                    opacity: 1,
                    stagger: { each: 0.05 },
                    duration: 0.8,
                    ease: 'expo.out'
                })
            }

            resetItems()

            ScrollTrigger.create({
                trigger: el,
                start: 'top bottom',
                end: 'bottom center',
                onEnter: () => {
                    resetItems()
                    setState(key)
                    animateItems()
                },
                // Scrolling back up: the items are still visible (they only scrolled away
                // upwards), so don't hide and re-animate them; that made them jump.
                onEnterBack: () => {
                    setState(key)
                },
                onLeaveBack: () => {
                    resetItems()
                    if (key === 'two') resetState()
                }
            })
        })

        gsap.set(letters, { color: lightGray })
    }
}

customElements.define('twozero-scroll', TwoZeroScroll)